(() => {
  function formatWithDelimiters(number, precision, thousands, decimal) {
    const value = Number(number);

    if (!Number.isFinite(value)) {
      return '0';
    }

    const formatted = (value / 100).toFixed(precision);
    const parts = formatted.split('.');
    const integer = parts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      `$1${thousands}`
    );
    const fraction = parts[1] ? `${decimal}${parts[1]}` : '';

    return integer + fraction;
  }

  function formatMoney(cents) {
    const format =
      window.theme?.strings?.moneyFormat ||
      '${{amount}}';

    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!match) {
      return formatWithDelimiters(cents, 2, ',', '.');
    }

    let value;

    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return format.replace(match[0], value);
  }

  function updateCardVariant(select) {
    const option = select.options[select.selectedIndex];
    const card = select.closest('.product-grid-item-redesign');

    if (!option || !card || !option.dataset.variantId) {
      return;
    }

    const form = card.querySelector('form.add-to-cart__form');
    const variantInput = form?.querySelector('input[name="id"]');

    if (variantInput) {
      variantInput.value = option.dataset.variantId;
    }

    const available = option.dataset.available === 'true';
    const button = form?.querySelector('.btn--add-to-cart');

    if (button) {
      button.disabled = !available;

      const buttonText = button.querySelector('.btn__text');

      if (buttonText) {
        buttonText.textContent = available
          ? button.dataset.addLabel
          : button.dataset.soldOutLabel;
      }
    }

    const priceContainer =
      card.querySelector('[data-price-container]') ||
      card.querySelector('.grid-product__price-wrap');

    if (priceContainer) {
      const regularPrice =
        priceContainer.querySelector('.grid-product__price');

      const compareWrapper =
        priceContainer.querySelector('.product-single__price--wrapper');

      const comparePrice =
        priceContainer.querySelector('[id="ComparePrice"]');

      const price = Number(option.dataset.price || 0);
      const compareAtPrice = Number(
        option.dataset.compareAtPrice || 0
      );

      if (regularPrice) {
        regularPrice.innerHTML = formatMoney(price);
        regularPrice.classList.toggle(
          'grid-product__price-sale',
          compareAtPrice > price
        );
      }

      if (compareWrapper) {
        const onSale = compareAtPrice > price;

        compareWrapper.classList.toggle('hide', !onSale);
        compareWrapper.setAttribute(
          'aria-hidden',
          onSale ? 'false' : 'true'
        );
      }

      if (comparePrice && compareAtPrice > price) {
        comparePrice.innerHTML = formatMoney(compareAtPrice);
      }
    }

    const imageUrl = option.dataset.imageUrl;

    if (imageUrl) {
      const image = card.querySelector(
        '.product--image:not(.product--image-second), .grid-product__image'
      );

      if (image) {
        image.src = imageUrl;
        image.dataset.src = imageUrl;
        image.removeAttribute('srcset');
        image.removeAttribute('data-srcset');
        image.classList.remove('lazyload');
        image.classList.add('lazyloaded');
      }
    }
  }

  function initializeProductCards(root = document) {
    root
      .querySelectorAll('.js-grid-variant-option')
      .forEach((select) => {
        if (select.dataset.defaultValue) {
          select.value = select.dataset.defaultValue;
        }

        updateCardVariant(select);
      });
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('.js-grid-variant-option')) {
      updateCardVariant(event.target);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    initializeProductCards();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeProductCards(event.target);
  });
})();
